import { useEffect, useState } from 'react';

import './ProjectSettingIframe.css';
import { ChromePicker } from 'react-color';
import { Button, MenuItem, Select, TextField } from '@material-ui/core';
import {
    generateNewIframeLink,
    handleColorChange,
    isDisableSettingUserNotRegisterAccess,
    isDisableSettingUserRegisterAccess,
    onChangeBorderSetting,
    onChangeInputNumber,
    onChangeSettingColor,
    onChangeSettingTypeSelect,
    onChangeSwitchGroupSetting,
    resetSetting,
    onChangeStyle,
    onChangeSubjectMailSetting
} from './handler/ProjectSettingIframeHandler';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { useRecoilState } from 'recoil';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import LoadingPanel from '../common/LoadingPanel';
import { RichTextSettingField } from './richtext/RichTextSettingField';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ProjectSettingIframe(props) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    // Init setting iframe
    const initData = {
        width: '600',
        height: '900',
        widthHeightUnit: 'px', // px/%
        marginWidth: '10',
        marginHeight: '20',
        borderSetting: true,
        borderStyle: 'none', // none/dashed/solid
        borderSize: '1px',
        borderColor: '#0d0e18',
        backgroundColor: '#ffffff',
        public: true,
        userRegisterAccess: true,
        userNotRegisterAccess: true,
        styleSheet: '',
        header: '',
        footer: '',
        customerInvitationSetting: Constant.CUSTOMER_INVITATION_SETTING.OFF,
        messageCompletedSendTicket: JSON.stringify(`<p style="text-align: center;">お問い合わせありがとうございました。<br/><br/>担当者より改めてご連絡させていただきます。</p>`),
        subjectMailCompletedSendTicket: 'お問い合わせありがとうございます。{contract_org}',
        contentMailCompletedSendTicket: JSON.stringify("<p>お問い合わせありがとうございます。担当者が確認して返信致します。</p>")
    };

    // Css color picker
    const popover = {
        position: 'absolute',
        zIndex: '2',
        top: '33px',
        left: '0px'
    };
    const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
    };

    const projectId = props.projectId;
    const corporationId = localStorageUtil.getAffiliationOrganization();
    const subDomain = localStorageUtil.getCorporationDomain();
    const [settingIframe, setSettingIframe] = useState(initData);
    const [iframeLink, setIframeLink] = useState('');
    const [iframeStyleSheet, setIframeStyleSheet] = useState('');
    const [iframeHeader, setIframeHeader] = useState('');
    const [iframeFooter, setIframeFooter] = useState('');
    const [displayBorderColorPicker, setDisplayBorderColorPicker] = useState(false);
    const [displayBackgroundColorPicker, setDisplayBackgroundColorPicker] = useState(false);

    // common projectList state
    const [projectList, setProjectList] = useRecoilState(projectListInCorporationAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const [isLoading, setIsLoading] = useState(false);
    const [errMsg, setErrMsg] = useState({});
    const [isDisableGenerateLink, setIsDisableGenerateLink] = useState(false)
    
    const argsCommon = {
        ...props,
        corporationId,
        subDomain,
        initData,
        settingIframe,
        setSettingIframe,
        iframeLink,
        setIframeLink,
        projectList,
        setProjectList,
        iframeStyleSheet,
        setIframeStyleSheet,
        iframeHeader,
        setIframeHeader,
        iframeFooter,
        setIframeFooter,
        projectInuseDetail,
        setProjectInuseDetail,
        setIsLoading,
        errMsg,
        setErrMsg
    };

    useEffect(() => {
        let currentProject = projectList.find(project => project.id === projectId);
        if (Utils.isEmptyObject(currentProject) || !currentProject.iframeSetting) return;
        let projectIframeSetting = Utils.convertJSONDataToObject(currentProject.iframeSetting);
        if (projectIframeSetting?.customerInvitationSetting === Constant.CUSTOMER_INVITATION_SETTING.ON) {
            projectIframeSetting.customerInvitationSetting = true;
        } else {
            projectIframeSetting.customerInvitationSetting = false;
        }
        const newSettingIframe = { ...initData, ...projectIframeSetting }
        setSettingIframe(newSettingIframe);
    }, [projectList, projectId]);

    //validate handle disable generate link button
    useEffect(() => {
        const dataValidate = isDataValidate(settingIframe)
        if (!dataValidate){
            setIsDisableGenerateLink(true);
        }else{
            setIsDisableGenerateLink(false);
        }
    }, [settingIframe]);

    const isDataValidate = iframeSetting => {
        const fieldsNeedValidate = [
            Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_MESSAGE,
            Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_SUBJECT_MAIL,
            Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_CONTENT_MAIL
        ];
        for (const field of fieldsNeedValidate) {
            if (!validateFields(field, iframeSetting[field])) return false
        }
        return true;
    };

    const validateFields = (fieldName, value) => {
        switch (fieldName) {
            case Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_MESSAGE:
            case Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_CONTENT_MAIL:
                //escape richtext
                const richtextFieldContent = getRichTextFieldContent(value);
                const valueRichText = Utils.escapeHtmlCharacters(richtextFieldContent);
                if (
                    Utils.isEmptyString(valueRichText) ||
                    Utils.isStringOverLength(valueRichText, 2000) || richtextFieldContent == `""`
                ) {
                    return false;
                }
                break;
            case Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_SUBJECT_MAIL:
                if (Utils.isEmptyString(value) || Utils.isStringOverLength(value, 50)) {
                    return false;
                }
                break;
            default:
                return true;
        }
        return true;
    };


    const renderListBorderSize = () => {
        let menuItems = [];
        for (var i = 1; i <= 10; i++) {
            menuItems.push(
                <MenuItem key={`borderSize-${i}`} value={`${i}px`}>{`${i}px`}</MenuItem>
            );
        }
        return menuItems;
    };

    return (
        <div className="settingIframe">
            <LoadingPanel isLoading={isLoading} />
            <div className="widthHeightContent mb-16">
                <h3 className="settingTitle">{trI18n('USER010LB001')}</h3>
                <div className="group-row">
                    <div className="groupInput">
                        <div className="group-col">
                            <label className="settingLable">{trI18n('USER010LB002')}</label>
                            <TextField
                                key="settingWidth"
                                className="common-input input-number form-control-wrapInput form-control-hg32"
                                variant="outlined"
                                name="width"
                                value={settingIframe.width}
                                defaultValue={settingIframe.width}
                                onKeyPress={Utils.onKeyPressNumber}
                                onPaste={Utils.handleOnPasteNumber}
                                onChange={e => onChangeInputNumber(e, 'width', argsCommon)}
                                inputProps={{ inputmode: 'numeric', pattern: '[0-9]*' }}
                            />
                        </div>
                        <div className="group-col group-right">
                            <label className="settingLable">{trI18n('USER010LB003')}</label>
                            <div className="heightContent">
                                <TextField
                                    key="settingHeight"
                                    className="common-input input-number form-control-wrapInput form-control-hg32"
                                    variant="outlined"
                                    name="height"
                                    value={settingIframe.height}
                                    defaultValue={settingIframe.height}
                                    onKeyPress={Utils.onKeyPressNumber}
                                    onPaste={Utils.handleOnPasteNumber}
                                    onChange={e => onChangeInputNumber(e, 'height', argsCommon)}
                                    inputProps={{ inputmode: 'numeric', pattern: '[0-9]*' }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="groupInputAdditional">
                        <Select
                            key="settingUnit"
                            className="unit form-control--selectControl form-control--hg32"
                            variant="outlined"
                            id="slect-unit"
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null
                            }}
                            value={settingIframe.widthHeightUnit}
                            onChange={e =>
                                onChangeSettingTypeSelect(e, argsCommon, 'widthHeightUnit')
                            }
                        >
                            <MenuItem value="px">px</MenuItem>
                            <MenuItem value="%">%</MenuItem>
                        </Select>
                    </div>
                </div>

                <div className="group-row">
                    <div className="groupInput">
                        <div className="group-col">
                            <label className="settingLable">{trI18n('USER010LB004')}</label>
                            <div className="settingMarginContent">
                                <TextField
                                    key="settingMarginWidth"
                                    className={`common-input input-number form-control-wrapInput form-control-hg32`}
                                    variant="outlined"
                                    name="marginWidth"
                                    value={settingIframe.marginWidth}
                                    defaultValue={settingIframe.marginWidth}
                                    onKeyPress={Utils.onKeyPressNumber}
                                    onPaste={Utils.handleOnPasteNumber}
                                    onChange={e =>
                                        onChangeInputNumber(e, 'marginWidth', argsCommon)
                                    }
                                    inputProps={{ inputmode: 'numeric', pattern: '[0-9]*' }}
                                />
                                <span className="marginUnit">px</span>
                            </div>
                        </div>
                        <div className="group-col group-right settingMarginHeight">
                            <label className="settingLable">{trI18n('USER010LB005')}</label>
                            <div className="settingMarginContent">
                                <TextField
                                    key="settingMarginHeight"
                                    className="common-input input-number form-control-wrapInput form-control-hg32"
                                    variant="outlined"
                                    name="marginHeight"
                                    value={settingIframe.marginHeight}
                                    defaultValue={settingIframe.marginHeight}
                                    onKeyPress={Utils.onKeyPressNumber}
                                    onPaste={Utils.handleOnPasteNumber}
                                    onChange={e =>
                                        onChangeInputNumber(e, 'marginHeight', argsCommon)
                                    }
                                    inputProps={{ inputmode: 'numeric', pattern: '[0-9]*' }}
                                />
                                <span className="marginUnit">px</span>
                            </div>
                        </div>
                    </div>

                    <div className="groupInputAdditional"></div>
                </div>
            </div>

            <div className="borderContent mb-16">
                <div className="borderStatus mb-10">
                    <label className="settingLable">{trI18n('USER010LB006')}</label>
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id="borderStatusId"
                            checked={settingIframe.borderSetting ? true : false}
                            defaultChecked={settingIframe.borderSetting ? true : false}
                        />
                        <label
                            htmlFor="borderStatusId"
                            onClick={e => onChangeBorderSetting(argsCommon)}
                        >
                            <span className="switch-text"></span>
                        </label>
                    </div>
                </div>

                <div className="borderStyle">
                    <div className="group-row">
                        <div className="group-col contentLeft">
                            <label className="settingLable">{trI18n('USER010LB007')}</label>
                            <Select
                                key="settingBorderStyle"
                                className="common-select form-control--wrap form-control--hg32"
                                variant="outlined"
                                id="slect-border-style"
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null
                                }}
                                disabled={!settingIframe.borderSetting}
                                value={settingIframe.borderStyle}
                                onChange={e =>
                                    onChangeSettingTypeSelect(e, argsCommon, 'borderStyle')
                                }
                            >
                                <MenuItem value="none">{trI18n('USER010LB008')}</MenuItem>
                                <MenuItem value="solid">{trI18n('USER010LB009')}</MenuItem>
                                <MenuItem value="dashed">{trI18n('USER010LB010')}</MenuItem>
                            </Select>
                        </div>
                        <div className="group-col contentRight">
                            <label className="settingLable">{trI18n('USER010LB011')}</label>
                            <Select
                                key="settingBorderSize"
                                className="common-select form-control--wrap form-control--hg32"
                                variant="outlined"
                                id="slect-border-size"
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null
                                }}
                                disabled={!settingIframe.borderSetting}
                                value={settingIframe.borderSize}
                                onChange={e =>
                                    onChangeSettingTypeSelect(e, argsCommon, 'borderSize')
                                }
                            >
                                {renderListBorderSize()}
                            </Select>
                        </div>
                    </div>

                    <div className="group-row">
                        <div className="group-col contentLeft borderColorPicker contentLeftWidth">
                            <label className="settingLable">{trI18n('USER010LB012')}</label>
                            <div className="borderColorPickerContent">
                                <div
                                    className="colorPreview"
                                    style={{ backgroundColor: `${settingIframe.borderColor}` }}
                                ></div>
                                <TextField
                                    key="settingBorderColor"
                                    className="common-input borderColorInput form-control-wrapInput form-control-hg32"
                                    variant="outlined"
                                    name="borderColor"
                                    autoComplete="off"
                                    disabled={!settingIframe.borderSetting}
                                    value={settingIframe.borderColor}
                                    defaultValue={settingIframe.borderColor}
                                    onChange={e =>
                                        onChangeSettingColor(e, 'borderColor', argsCommon)
                                    }
                                    // onBlur={e =>
                                    //     onChangeSettingColor(e, 'borderColor', argsCommon)
                                    // }
                                    // onKeyPress={e =>
                                    //     onChangeSettingColor(e, 'borderColor', argsCommon)
                                    // }
                                    onClick={e => {
                                        if (!settingIframe.borderSetting) return;
                                        setDisplayBorderColorPicker(!displayBorderColorPicker);
                                    }}
                                />
                                {displayBorderColorPicker ? (
                                    <div style={popover}>
                                        <div
                                            style={cover}
                                            onClick={e => setDisplayBorderColorPicker(false)}
                                        />
                                        <ChromePicker
                                            color={
                                                settingIframe.borderColor
                                                    ? settingIframe.borderColor
                                                    : '#ffffff'
                                            }
                                            onChange={color =>
                                                handleColorChange(color, argsCommon, 'borderColor')
                                            }
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="group-col contentRight backgroundColorPicker"></div>
                    </div>
                </div>
            </div>

            <div className="groupSetting mb-16">
                <h3 className="mb-10 settingTitle">{trI18n('USER010LB022')}</h3>
                <div className="embeddedCode mb-10">
                    <label className="settingLable">{trI18n('USER010LB019')}</label>
                    <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        value={settingIframe.styleSheet}
                        defaultValue={settingIframe.styleSheet}
                        placeholder={trI18n('USER010PL001')}
                        minRows={2}
                        maxRows={2}
                        onChange={e => {
                            setIframeStyleSheet(e.target.value);
                            onChangeStyle(e, 'style', argsCommon);
                        }}
                        error={iframeStyleSheet.length > 20000 ? true : false}
                        helperText={
                            iframeStyleSheet.length > 20000
                                ? tr(I18n.get('COMMSG037').replace('＜X＞', '＜20000＞'))
                                : ''
                        }
                    />
                </div>

                <div className="embeddedCode mb-10">
                    <label className="settingLable">{trI18n('USER010LB020')}</label>
                    <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        value={settingIframe.header}
                        defaultValue={settingIframe.header}
                        placeholder={trI18n('USER010PL002')}
                        minRows={2}
                        maxRows={2}
                        onChange={e => {
                            setIframeHeader(e.target.value);
                            onChangeStyle(e, 'header', argsCommon);
                        }}
                        error={iframeHeader.length > 20000 ? true : false}
                        helperText={
                            iframeHeader.length > 20000
                                ? tr(I18n.get('COMMSG037').replace('＜X＞', '＜20000＞'))
                                : ''
                        }
                    />
                </div>

                <div className="embeddedCode mb-10">
                    <label className="settingLable">{trI18n('USER010LB021')}</label>
                    <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        value={settingIframe.footer}
                        defaultValue={settingIframe.footer}
                        placeholder={trI18n('USER010PL003')}
                        minRows={2}
                        maxRows={2}
                        onChange={e => {
                            setIframeFooter(e.target.value);
                            onChangeStyle(e, 'footer', argsCommon);
                        }}
                        error={iframeFooter.length > 20000 ? true : false}
                        helperText={
                            iframeFooter.length > 20000
                                ? tr(I18n.get('COMMSG037').replace('＜X＞', '＜20000＞'))
                                : ''
                        }
                    />
                </div>
                <div className="group-row">
                    <div className="group-col contentLeft backgroundColorPicker contentLeftWidth">
                        <label className="settingLable">{trI18n('USER010LB013')}</label>
                        <div className="backgroundColorPickerContent">
                            <div
                                className="colorPreview"
                                style={{ backgroundColor: `${settingIframe.backgroundColor}` }}
                            ></div>
                            <TextField
                                key="settingBackgroundColor"
                                className="common-input borderColorInput form-control-wrapInput form-control-hg32"
                                variant="outlined"
                                name="backgroundColor"
                                autoComplete="off"
                                value={settingIframe.backgroundColor}
                                defaultValue={settingIframe.backgroundColor}
                                onChange={e =>
                                    onChangeSettingColor(e, 'backgroundColor', argsCommon)
                                }
                                // onBlur={e =>
                                //     onChangeSettingColor(e, 'backgroundColor', argsCommon)
                                // }
                                // onKeyPress={e =>
                                //     onChangeSettingColor(e, 'backgroundColor', argsCommon)
                                // }
                                onClick={e =>
                                    setDisplayBackgroundColorPicker(!displayBackgroundColorPicker)
                                }
                            />
                            {displayBackgroundColorPicker ? (
                                <div style={popover}>
                                    <div
                                        style={cover}
                                        onClick={e => setDisplayBackgroundColorPicker(false)}
                                    />
                                    <ChromePicker
                                        color={
                                            settingIframe.backgroundColor
                                                ? settingIframe.backgroundColor
                                                : '#ffffff'
                                        }
                                        onChange={color =>
                                            handleColorChange(color, argsCommon, 'backgroundColor')
                                        }
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="group-col contentRight backgroundColorPicker"></div>
                </div>
            </div>

            <div className="groupSetting mb-16">
                <h3 className="mb-10 settingTitle">{trI18n('USER010LB014')}</h3>
                <div className="groupSettingContent">
                    <div className="publicStatus mb-10 groupSettingItem">
                        <label className="settingLable">{trI18n('USER010LB015')}</label>
                        <div className="switch-check">
                            <input
                                type="checkbox"
                                id="publicStatusId"
                                defaultChecked={settingIframe.public ? true : false}
                                checked={settingIframe.public ? true : false}
                            />
                            <label
                                htmlFor="publicStatusId"
                                onClick={e => onChangeSwitchGroupSetting(argsCommon, 'public')}
                            >
                                <span className="switch-text"></span>
                            </label>
                        </div>
                    </div>

                    <div className="publicStatus mb-10 groupSettingItem">
                        <label className="settingLable">{trI18n('USER010LB016')}</label>
                        <div className="switch-check">
                            <input
                                type="checkbox"
                                id="accessUserRegisterId"
                                defaultChecked={settingIframe.userRegisterAccess ? true : false}
                                checked={settingIframe.userRegisterAccess ? true : false}
                                disabled={isDisableSettingUserRegisterAccess(argsCommon)}
                            />
                            <label
                                htmlFor="accessUserRegisterId"
                                onClick={e =>
                                    onChangeSwitchGroupSetting(argsCommon, 'userRegisterAccess')
                                }
                            >
                                <span className="switch-text"></span>
                            </label>
                        </div>
                    </div>

                    <div className="publicStatus mb-10 groupSettingItem">
                        <label className="settingLable">{trI18n('USER010LB017')}</label>
                        <div className="switch-check">
                            <input
                                type="checkbox"
                                id="accessUserNotRegisterId"
                                defaultChecked={settingIframe.userNotRegisterAccess ? true : false}
                                checked={settingIframe.userNotRegisterAccess ? true : false}
                                disabled={isDisableSettingUserNotRegisterAccess(argsCommon)}
                            />
                            <label
                                htmlFor="accessUserNotRegisterId"
                                onClick={e =>
                                    onChangeSwitchGroupSetting(argsCommon, 'userNotRegisterAccess')
                                }
                            >
                                <span className="switch-text"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="groupSettingContent">
                    <div className="publicStatus mb-10 groupSettingItem">
                        <h3 className="mb-10 settingLable-email-mode settingTitle ">
                            {trI18n('CUSTOMER-INVITATION-SETTING')}
                        </h3>
                        <div className="switch-check">
                            <input
                                type="checkbox"
                                id="publicStatusId"
                                defaultChecked={settingIframe.customerInvitationSetting ? true : false}
                                checked={settingIframe.customerInvitationSetting ? true : false}
                            />
                            <label
                                htmlFor="publicStatusId"
                                onClick={e =>
                                    onChangeSwitchGroupSetting(argsCommon, 'customerInvitationSetting')
                                }
                            >
                                <span className="switch-text"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="groupSetting mb-16">
                <h3 className="mb-10 settingTitle">
                    {trI18n('LABEL-MESSAGE-DISPLAY-SETTING')} <span className="required">*</span>
                </h3>
                <div className="mb-10 field-richtext">
                    <RichTextSettingField
                        name={Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_MESSAGE}
                        setSettingIframe={setSettingIframe}
                        required={true}
                        setErrMsg={setErrMsg}
                        errMsg={errMsg}
                        settingIframe={settingIframe}
                    />
                </div>
            </div>
            <div className="groupSetting mb-16">
                <h3 className="mb-10 settingTitle">
                    {trI18n('LABEL-EMAIL-SUBJECT-SETTING')} <span className="required">*</span>
                </h3>
                <div className="mb-10">
                    <TextField
                        key={Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_SUBJECT_MAIL}
                        className='common-input input-number form-control-wrapInput form-control-hg32'
                        variant="outlined"
                        name={Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_SUBJECT_MAIL}
                        value={settingIframe?.subjectMailCompletedSendTicket}
                        defaultValue={settingIframe?.subjectMailCompletedSendTicket}
                        required
                        onChange={e =>
                            onChangeSubjectMailSetting(e, argsCommon, {
                                type: Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_SUBJECT_MAIL,
                                required: true
                            })
                        }
                        error={!!errMsg?.subjectMailCompletedSendTicket}
                        helperText={errMsg?.subjectMailCompletedSendTicket}
                    />
                </div>
            </div>
            <div className="groupSetting mb-16">
                <h3 className="mb-10 settingTitle">
                    {trI18n('LABEL-EMAIL-BODY-SETTING')} <span className="required">*</span>
                </h3>
                <div className="embeddedCode mb-10 field-richtext">
                    <RichTextSettingField
                        name={ Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_CONTENT_MAIL}
                        setSettingIframe={setSettingIframe}
                        required={true}
                        setErrMsg={setErrMsg}
                        errMsg={errMsg}
                        settingIframe={settingIframe}
                    />
                </div>
            </div>
            <div className="groupBtn mb-10">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-light"
                    color="primary"
                    onClick={e => resetSetting(argsCommon, projectList, projectId)}
                >
                    {trI18n('USER10BTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-hg32 btn-primary"
                    color="primary"
                    onClick={e => generateNewIframeLink(argsCommon)}
                    disabled={isDisableGenerateLink}
                >
                    {trI18n('USER10BTN003')}
                </Button>
            </div>

            <div className="embeddedCode mb-10">
                <h3 className="mb-10 settingTitle">{trI18n('USER010LB018')}</h3>
                <TextField
                    multiline
                    fullWidth
                    variant="outlined"
                    value={iframeLink}
                    defaultValue={iframeLink}
                    minRows={4}
                    maxRows={4}
                    onChange={e => {
                        setIframeLink(e.target.value);
                    }}
                />
            </div>

            <div className="copyIframe">
                <Button
                    className="buttonCopyIframe"
                    onClick={e => navigator.clipboard.writeText(iframeLink)}
                >
                    <img src="/assets/image/copy-iframe.svg" alt="Copy iframe" />
                    {trI18n('USER10BTN004')}
                </Button>
            </div>
        </div>
    );
}
